/**
 * The words of a `source.query` route's refusals (`answerList` in sdk-backend-ts, list-query.ts):
 * the problem keys it writes, so a refused filter reads in the viewer's language. Kept beside the
 * catalogue and spread into it, so a parallel change to the catalogue does not collide with these.
 */
export const LIST_QUERY_EN = {
    'list.reread.failed': 'The list could not be read again with these filters. What you see is what was read before.',
    'list.refusal.where': 'The filters could not be read as conditions. Clear them and choose again.',
    'list.refusal.depth': 'Conditions can be grouped one level deep, no more.',
    'list.refusal.value': 'A filter holds a value its column cannot hold.',
    'list.refusal.export_cap': '{rows} rows is more than one file carries ({cap}). Narrow the filters first.',
};
export const LIST_QUERY_AR = {
    'list.reread.failed': 'تعذّرت قراءة القائمة من جديد بهذه الشروط، وما تراه هو ما قُرئ قبلها.',
    'list.refusal.where': 'تعذّرت قراءة عوامل التصفية شروطًا. امسحها واخترها من جديد.',
    'list.refusal.depth': 'تُجمَّع الشروط في مستوى واحد لا أكثر.',
    'list.refusal.value': 'في عامل تصفية قيمةٌ لا يحملها عموده.',
    'list.refusal.export_cap': '{rows} صفًّا أكثر مما يحمله ملف واحد ({cap}). ضيّق التصفية أولًا.',
};
//# sourceMappingURL=i18n-list-query.js.map